import {SelectionModel} from '@angular/cdk/collections';
import {ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '../../shared/shared.service';
import { Roles } from '../../shared/enums/roles';
import { OrganizationTo } from '../../shared/models/organizationTo';
import { PositionAliasTo } from '../../shared/models/positionAliasTo';
import { PositionAliasService } from '../position-alias.service';
import { AddPositionAliasComponent } from '../add-position-alias/add-position-alias.component';
import { UpdatePositionAliasComponent } from '../update-position-alias/update-position-alias.component';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Alerts } from '../../shared/enums/alerts';

@Component({
    selector: 'app-list-position-alias',
    templateUrl: './list-position-alias.component.html',
    styleUrl: './list-position-alias.component.scss'
})
export class ListPositionAliasComponent implements OnInit {

    roles = Roles;
    selectedOrg: OrganizationTo;
    isLoading: boolean = true;
    isDeletingPositionAlias: boolean = false;
    displayFailureMsg: boolean = false;
    displayedColumns: string[] = ['positionId', 'alias', 'actions'];
    positionAliasList: PositionAliasTo[] = [];
    dataSource = new MatTableDataSource<PositionAliasTo>(this.positionAliasList);
    selection = new SelectionModel<PositionAliasTo>(true, []);
    
    dialogRef: MatDialogRef<unknown, any>;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    paginatorLength: number;

    constructor(@Inject(MAT_DIALOG_DATA) public data: OrganizationTo,
                public listDialogRef: MatDialogRef<ListPositionAliasComponent>,
                public dialog: MatDialog,
                public positionAliasService: PositionAliasService,
                public sharedService: SharedService,
                private cdref: ChangeDetectorRef) {
        
    }
  
    ngOnInit() {
        this.isLoading = true;
        this.selectedOrg = this.data;
        this.getPositionAliasList();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    getPositionAliasList() {
        this.positionAliasService.getPositionAliasList(this.selectedOrg.clientId).subscribe({
            next: data => {
                this.isLoading = false;
                this.displayFailureMsg = false;
                this.positionAliasList = data;
                this.dataSource = new MatTableDataSource<PositionAliasTo>(this.positionAliasList);
                this.setPositionAliasList();
            },
            error: err => {
                this.displayFailureMsg = true;
                this.isLoading = false;
            },
            complete: () => { }
        });   
    }

    setPositionAliasList() {
        if (this.positionAliasList.length > 20) {
            this.paginatorLength = this.positionAliasList.length;
        } else {
            this.paginatorLength = 20;
        }
        const currentfilter = this.dataSource.filter;
        this.dataSource = new MatTableDataSource<PositionAliasTo>(this.positionAliasList);
        this.dataSource.filter = currentfilter;
        this.dataSource.filterPredicate = (data: PositionAliasTo, filter: string) =>
            data.positionId.toString().toLowerCase().indexOf(filter) !== -1 || 
            data.alias.trim().toLowerCase().indexOf(filter) !== -1;
        setTimeout(() => this.dataSource.paginator = this.paginator);
        this.dataSource.sortingDataAccessor = (data: PositionAliasTo, sortHeaderId: string): string => {
            if (typeof data[sortHeaderId] === 'string') {
                return data[sortHeaderId].toLocaleLowerCase();
            }
            return data[sortHeaderId];
        };
        this.dataSource.sort = this.sort;
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    addPositionAlias() {
        this.dialogRef = this.dialog.open(AddPositionAliasComponent, {
            data: this.selectedOrg,
            width: '550px'
        });
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getPositionAliasList();
            }
        });
    }

    editPositionAlias(object: PositionAliasTo) {
        this.dialogRef = this.dialog.open(UpdatePositionAliasComponent, {
            data: object,
            width: '550px'
        });
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getPositionAliasList();
            }
        });
    }

    deletePositionAlias(object: PositionAliasTo) {
        Swal.fire({
            title: 'Are you sure?',
            text: "Delete the position alias '" + object.alias + "'",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, Delete',
            cancelButtonText: 'No, Cancel',
            showLoaderOnConfirm: true
        }).then((result:any) => {
            if (result.value) {
                this.isDeletingPositionAlias = true;
                this.positionAliasService.deletePositionAlias(object.id).subscribe({
                    next: data => {
                        this.isDeletingPositionAlias = false;
                        this.sharedService.showAlert(Alerts.SUCCESS, "Position alias '" + object.alias + "' has been deleted.");
                        this.getPositionAliasList();
                    },
                    error: error => {
                        this.isDeletingPositionAlias = false;
                        this.sharedService.showAlert(Alerts.ERROR, "Unable to delete position alias '" + object.alias + "'.");
                        this.getPositionAliasList();
                    },
                    complete: () => {}
                });
            }
        });
    }

    bulkUpload() {

    }

    closeList() {
        this.listDialogRef.close(false);
    }

    syncPrimaryPaginator(event: PageEvent) {
        this.paginator.pageIndex = event.pageIndex;
        this.paginator.pageSize = event.pageSize;
        this.paginator.page.emit(event);
    }
}
